import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePriceBand } from 'src/api/deletePriceBand';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from '../QueryKeys';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';

export const useDeletePriceBand = (onMutationSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ priceBand, priceSchemeId }: { priceBand: IPriceBandWithVenues; priceSchemeId: string }) =>
      await deletePriceBand(priceBand.priceBandId, priceSchemeId),
    {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: [getBrandId(), QueryKeys.priceBands, variables.priceSchemeId],
        });
        showSnackbar({
          message: `You have successfully deleted ${variables.priceBand.name} price band!`,
          status: SnackbarStatus.SUCCESS,
        });
        if (onMutationSuccess) onMutationSuccess();
      },
      onError: (error) => {
        showSnackbar({
          status: SnackbarStatus.ERROR,
          message: error instanceof Error ? error.message : 'You cannot delete this price band yet',
        });
      },
    },
  );
};
